import { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded, FlightRounded, DeliveryDiningRounded }  from '@mui/icons-material'

import { google, marketing, social, emailPromotion, emailMarketing, img1, img2, nurse, physicalTherapy, speech, occupationalTherapy, gallery1, gallery12, gallery11, gallery10, gallery9, gallery8, gallery7, gallery6, gallery5, gallery4, gallery3, gallery2 } from '../assets';

export { LightModeRounded, ModeNightRounded, KeyboardArrowUpRounded, KeyboardArrowDownRounded, KeyboardArrowRightRounded, KeyboardBackspaceRounded, FiberSmartRecordRounded, RemoveRounded, CloudUploadRounded, DoneAllRounded, DownloadRounded, MenuRounded, CloseRounded, Twitter, Instagram, PhotoRounded, FacebookRounded, WhatsApp, Telegram, Mail, LocationOn, LinkRounded, CallRounded, EmailRounded, SearchRounded, ShutterSpeedRounded, NoteAltRounded, NetworkPingRounded, PeopleRounded, Visibility, VisibilityOff, PasswordRounded, BlockRounded, CheckCircleOutlineRounded, ProductionQuantityLimitsRounded, Business, LocalConvenienceStoreRounded, DesignServicesRounded, StarOutlineRounded, StarRateRounded, AddShoppingCartRounded, ShoppingBasketRounded, DeleteOutlineRounded, AddRounded, PaymentsRounded, LocalShippingRounded, ShoppingCartCheckoutRounded, FavoriteBorderRounded, FavoriteRounded, MarkEmailReadRounded, LockRounded, AddBoxRounded, PageviewRounded, EditRounded, VisibilityRounded, NotificationsNoneRounded, DeleteRounded, PersonRounded, AccountBoxRounded, HourglassEmptyRounded, SupportAgentRounded, ShareRounded, SchoolRounded, AccountBalanceRounded, RocketLaunchRounded, PublicRounded }


export const navLinks = [
  { name: 'home', link: '/'},
  { name: 'posts', link: '/posts'},
  { name: 'items', link: '/items'},
  { name: 'services', link: '/services'},
  // { name: 'extras'},
]

export const newsEventsList = [
  {
    title: "Upcoming activities and outings",
  },
  {
    title: "Holiday celebrations and special events",
  },
  {
    title: "Community news and updates",
  },
]

export const genderOptions = [
  {name: "male"},
  {name: "female"},
]

// title: "The Grandview"
// title: "Crown Residences"
// title: "The Opal"
// title: "Aurum Suites"
// title: "The Ivory"
// title: "Luxe Heights"
// title: "The Meridian"
// title: "Velour Living"
// title: "The Echelon"
// title: "Sovereign Place"
// title: "The Crest"
// title: "Élan Residences"

export const cardData = [
  {
    title: "",
    image: gallery1,
  },
  {
    title: "",
    image: gallery2,
  },
  {
    title: "",
    image: gallery3,
  },
  {
    title: "",
    image: gallery4,
  },
  {
    title: "",
    image: gallery5,
  },
  {
    title: "",
    image: gallery6,
  },
  {
    title: "",
    image: gallery7,
  },
  {
    title: "",
    image: gallery8,
  },
  {
    title: "",
    image: gallery9,
  },
  {
    title: "",
    image: gallery10,
  },
  {
    title: "",
    image: gallery11,
  },
  {
    title: "",
    image: gallery12,
  },
];

export const personalizedCare = [
  {
    question: "Skilled Nursing Services",
    answer: "Professional Nurses provide clinical care, medication management and recovery support at home.",
  },
  {
    question: "Physical and occupational Therapy",
    answer: "Restores mobility, strength and independence after illness or injury. Helps clients regain daily living skills and adapt safely at home",
  },
  {
    question: "Chronic Care",
    answer: "Supports long-term management of diabetes, heart disease and more...",
  },
];

export const testimonialsData = [
  {
    title: "Shalom Springs feels like home. The staff are like family!",
    name: "Rachel, resident",
    icon: img1
  },
  {
    title: "Best decision we made for Mom's care. Peace of mind for us.",
    name: "John, family member",
    icon: img2
  },
  {
    title: "Love the activities and friends I've made here!",
    name: "David, resident",
    icon: img2
  },
  {
    title: "Compassionate care and beautiful surroundings.",
    name: " Emily, family",
    icon: img1
  },
]

export const servicesData = [ 
  {
    title: "Residential care and accommodations.",
  },
  {
    title: "Activities and engagement.",
  },
  {
    title: "24 Hrs Registered nurse on-call.",
  },
  {
    title: "Trained Staff on-site 24/7",
  },
  {
    title: "Care Coordination with other professionals such as physician, pharmacist, therapists...",
  },
  {
    title: "Personal care assistance (bathing, dressing, toileting) all activities of daily living.",
  },
  {
    title: "Meal preparation and diet monitoring",
  },
  {
    title: "Housekeeping & laundry",
  },
  {
    title: "Medication management",
  },
  {
    title: "Respite Care",
  },
  {
    title: "Range of motion exercises",
  },
]

export const amenitiesData = [
  {
    title: "Spacious living areas and private rooms"
  },
  {
    title: "Wifi services"
  },
  {
    title: "Salon or spa services"
  },
  {
    title: "Beautiful gardens and outdoor spaces"
  },
]

export const meetTeamData = [
  {
    name: "Chiamaka Oyemike",
    title: "CEO & Founder",
    image: img2,
  }
]


export const faqs = [
    {
      id: 0,  
      header: "how do i navigate market place profile ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 1,
      header: "how do i contact customer support ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum"
    },
    {
      id: 2,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 3,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    },
    {
      id: 4,
      header: "Is my email address visible to others ?",
      text: "Velit ipsum amet minim laborum voluptate aliquip fugiat enim ipsum sit sunt. Excepteur tempor ad sit commodo ut occaecat cillum tempor nisi in. Mollit dolore eiusmod aliqua irure laborum amet laboris. Enim nostrud anim ut velit aliquip ad quis irure fugiat ex aliqua aliqua elit. Ipsum officia sit quis sint. Anim enim qui qui do duis qui consequat cillum."
    }
]

export const featuresList = [
    {id: 1, icon: PublicRounded, title: 'Global Sourcing.', detail: 'Hexagon China helps businesses source quality products directly from China.'},
    {id: 2, icon: FlightRounded, title: 'We make China sourcing sample.', detail: '3-layer quality inspections before shipping'},
    {id: 3, icon: LocalShippingRounded, title: 'Africa-friendly services', detail: 'Seamless door-to-door shipping and customs handling'},
]

